import { Link, useNavigate } from "react-router-dom";
import useCustomerAuth from "../../legacy/hooks/useCustomerAuth";
import MobileLayout from "../layouts/MobileLayout";

const menu = [
  { label: "My bookings", to: "/guest/bookings", icon: "bi-calendar-check" },
  { label: "Wishlist", to: "/guest/wishlist", icon: "bi-heart" },
  { label: "Payments", to: "/guest/payments", icon: "bi-credit-card" },
  { label: "Support", to: "/guest/support", icon: "bi-headset" },
  { label: "Profile", to: "/guest/profile", icon: "bi-person" },
];

export default function MobileAccount() {
  const auth = useCustomerAuth();
  const navigate = useNavigate();
  const loggedIn = Boolean(auth.customer && auth.accessToken);
  const name = auth.customer?.full_name || auth.customer?.name || "Your Homevilas";
  const logout = async () => { await auth.logout(); navigate("/", { replace: true }); };
  return (
    <MobileLayout>
      <section className="hv-card" style={{ padding: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div className="hv-footer-logo">H</div>
          <div>
            <h1 className="hv-section-title" style={{ fontSize: 26 }}>{auth.loading ? "Loading..." : name}</h1>
            <div className="hv-muted-row">{loggedIn ? (auth.customer?.email || auth.customer?.phone || "Homevilas member") : "Login to see trips and saved stays"}</div>
          </div>
        </div>
        {!auth.loading && !loggedIn ? <Link className="hv-primary-btn" to="/account/login" style={{ marginTop: 16, width: "100%" }}>Login / Register</Link> : null}
      </section>
      <section className="hv-section">
        <div className="hv-list-stack">
          {(loggedIn ? menu : menu.filter((item) => item.label === "Support")).map((item) => (
            <Link key={item.label} to={item.to} className="hv-card" style={{ display: "flex", alignItems: "center", gap: 12, padding: 15, color: "inherit", textDecoration: "none" }}>
              <i className={`bi ${item.icon}`} aria-hidden="true" />
              <strong style={{ flex: 1 }}>{item.label}</strong>
              <i className="bi bi-chevron-right" aria-hidden="true" />
            </Link>
          ))}
          {loggedIn ? <button className="hv-card" onClick={logout} type="button" style={{ border: "1px solid var(--hv-border)", padding: 15, textAlign: "left", color: "var(--hv-maroon)", fontWeight: 800 }}>Logout</button> : null}
        </div>
      </section>
    </MobileLayout>
  );
}
